import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';

interface CardProps {
	backgroundColor?: string;
	backgroundImage?: string;
	children?: React.ReactNode;
}

export default function Card({ backgroundColor, backgroundImage, children }: CardProps) {
	return (
		<View style={[styles.card, { backgroundColor: backgroundColor ?? Colors.white }]}>
			{backgroundImage ? (
				<Image resizeMode={'cover'} source={{ uri: backgroundImage }} style={styles.cardBgImage} />
			) : null}
			{children}
		</View>
	);
}

const styles = StyleSheet.create({
	card: {
		flex: 1,
		paddingBottom: Dimens.padding12,
		backgroundColor: Colors.white,
	},
	cardBgImage: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		width: '100%',
	},
});
